import { ActionMenu } from "@telluscompany/design-system";
import { MoreVerticalIcon, Trash2 } from "lucide-react";

import { useLocalization } from "@i18n";

import type { ListAdminLicenseAssignmentsResponseItem } from "../../api/license-assignments";

interface AdminLicenseAssignmentsActionMenuProps {
  assignment: ListAdminLicenseAssignmentsResponseItem;
  onRevoke: (assignment: ListAdminLicenseAssignmentsResponseItem) => void;
}

export const AdminLicenseAssignmentsActionMenu = ({
  assignment,
  onRevoke,
}: AdminLicenseAssignmentsActionMenuProps) => {
  const { translate } = useLocalization();

  return (
    <ActionMenu
      menu={[
        {
          actions: [
            {
              label: translate("admin.licenseAssignments.button.revoke"),
              onClick: () => onRevoke(assignment),
              icon: <Trash2 size={16} />,
              colorTitle: "red" as const,
            },
          ],
        },
      ]}
      trigger={<MoreVerticalIcon />}
    />
  );
};
